import { useState, useCallback, useEffect } from 'react';
import { getApiBaseUrl } from '../../../../core/config/api';

export function usePriseAppels(userId: number | undefined) {
  const [priseAppels, setPriseAppels] = useState(false);
  const [priseLoadError, setPriseLoadError] = useState<string | null>(null);
  const [priseToggling, setPriseToggling] = useState(false);

  const loadPriseAppels = useCallback(async () => {
    if (!userId) return;
    setPriseLoadError(null);
    try {
      const token = localStorage.getItem('token') || localStorage.getItem('auth_token') || '';
      if (!token) return;
      const res = await fetch(`${getApiBaseUrl()}/api/cta/prise-appels`, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      });
      const data = await res.json().catch(() => ({}));
      if (data?.success && typeof data?.prise_appels === 'boolean') {
        setPriseAppels(data.prise_appels);
      } else {
        setPriseLoadError("Impossible de charger l'état de prise d'appel.");
      }
    } catch {
      setPriseLoadError("Impossible de charger l'état de prise d'appel.");
    }
  }, [userId]);

  const togglePriseAppels = useCallback(async () => {
    if (!userId || priseToggling) return;
    setPriseToggling(true);
    setPriseLoadError(null);
    try {
      const token = localStorage.getItem('token') || localStorage.getItem('auth_token') || '';
      if (!token) return;
      const res = await fetch(`${getApiBaseUrl()}/api/cta/prise-appels`, {
        method: 'PUT',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ prise_appels: !priseAppels }),
      });
      const data = await res.json().catch(() => ({}));
      if (data?.success && typeof data?.prise_appels === 'boolean') {
        setPriseAppels(data.prise_appels);
      } else {
        setPriseLoadError("Échec du changement de prise d'appel.");
      }
    } catch {
      setPriseLoadError("Échec du changement de prise d'appel.");
    } finally {
      setPriseToggling(false);
    }
  }, [userId, priseAppels, priseToggling]);

  useEffect(() => {
    void loadPriseAppels();
  }, [loadPriseAppels]);

  return { priseAppels, setPriseAppels, priseLoadError, priseToggling, togglePriseAppels };
}
